import storeApi from "../services/api/Store";
import excursionApi from "../services/api/Excursion";
import cartApi from "../services/api/Cart";

export const fetchStore = async (id: string) => {
  try {
    const storeResponse = await storeApi.getStore(id);
    return storeResponse;
  } catch (error) {
    console.warn("Error fetching store: ", error);
  }
};

export const fetchManagerStores = async (id: string) => {
  try {
    const managerStoresResponse = await storeApi.getManagerStores(id);
    return managerStoresResponse;
  } catch (error) {
    console.warn("Error fetching manager's stores: ", error);
  }
};

export const fetchExcursion = async (id: string) => {
  try {
    const response = await excursionApi.getExcursion(id);
    return response;
  } catch (error) {
    console.warn("Error fetching excursion: ", error);
  }

  return null;
};

export const fetchExcursionsFromStore = async (storeId: string) => {
  try {
    const storeExcursionResponse =
      await excursionApi.getExcursionsFromAStore(storeId);
    return storeExcursionResponse;
  } catch (error) {
    console.warn("Error fetching store's excursions: ", error);
  }
};

export const fetchShoppingCart = async (userId: string) => {
  try {
    const shoppingCartResponse = await cartApi.getUserCart(userId);
    return shoppingCartResponse;
  } catch (error) {
    console.warn("Error fetching user's shopping cart: ", error);
  }
};
